module.exports = __webpack_public_path__ + "static/media/help.d2bf4a33.md";